import { Pipe, PipeTransform, Inject } from '@angular/core';
import { Session } from '../services/session';
import { moment, IMoment } from '../lib/moment';

import { MomentFormatter } from '../services/moment-formatter';

function isSameYear(dateTime) {
  return dateTime.isSame(moment(), 'year');
}

function isSameDay(dateTime) {
  return dateTime.isSame(moment(), 'day');
}

@Pipe({ name: 'timestamp' })
export class TimestampPipe implements PipeTransform {
  constructor(
    @Inject(Session) private session: Session,
    private momentFormatter: MomentFormatter,
    ) {}

  public transform(dateTime, providedTimeFormat: string = '', useUserTimezone: boolean = true) {
    dateTime = moment(dateTime);
    if (!dateTime.isValid) return '';
    if (useUserTimezone && !dateTime.tz()) dateTime = moment(dateTime).mapTz(this.session.getUserTimeZone());
    let format = providedTimeFormat ? providedTimeFormat : this.momentFormatter.time('hh:mm A');
    if (!isSameYear(dateTime)) {
      format = `M/D/YYYY ${providedTimeFormat ? format : ''}`;
    } else if (!isSameDay(dateTime)) {
      format = `MMM DD ${providedTimeFormat ? format : ''}`;
    }
    return dateTime.format(format);
  }
}
